export const redirectUserToHome = (user, history) => {
    const userType= user.user?.type || user.type;
    history.push(userType == 2 ? "/provider/daily": (userType == 3 ? "/client/daily": 'dashboard'));
}
